import { AddModel, add } from './add'
import { CityModel, city } from './city'
import { DataModel, data } from './data'
import { EditModel, edit } from './edit'
import { ProvinceModel, province } from './province'
import { RemoveModel, remove } from './remove'

export interface AddressModel {
	add: AddModel
	city: CityModel
	data: DataModel
	edit: EditModel
	province: ProvinceModel
	remove: RemoveModel
}

export const address: AddressModel = {
	add,
	city,
	data,
	edit,
	province,
	remove
}
